import {FC, useState, createContext, useContext} from 'react'
import {AuthModel} from './_models'
import * as authHelper from './AuthHelpers'
import {WithChildren} from '../../../../_metronic/helpers'

type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  logout: () => void
  redirect: string
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  logout: () => {},
  redirect: 'dashboard',
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())

  const urlParams = new URLSearchParams(window.location.search)
  const redirect = urlParams.get('redirect') || 'dashboard'

  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = () => {
    saveAuth(undefined)
    
    // Limpar TODAS as informações do usuário do localStorage
    // Mantém apenas configurações globais (tema, idioma)
    const keysToRemove = [
      'filtros_globais_v1',              // Filtros globais de corporação/organização
      'menuVisaoGeralFilters',           // Filtros da visão geral
      'menuAlertTestPageFilters',        // Filtros de alertas
      'customStandardIcons'              // Cache de ícones customizados
    ]
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key)
      console.log(`🧹 Removido do localStorage: ${key}`)
    })
    
    console.log('✅ Todas as informações do usuário foram limpas do localStorage')
  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, logout, redirect}}>
      {children}
    </AuthContext.Provider>
  )
}

export {AuthProvider, useAuth}
